import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  ${(p) => p.theme.typography.description}
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TagSelectorWrapper = styled.div`
  padding-left: 24px;
  padding-top: 8px;
`;
